<template>
  <div class="addForm">
    <el-dialog
      :title="'通知列表'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="70%"
      :before-close="handleClose"
      :modal="false"
      :destroy-on-close="true"
      custom-class="jg-file-viewer"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="content">
        <table-list
          :tableTitle="tableTitle"
          :tableData="tableData"
          height="54vh"
          :modifyShow="false"
          :viewShow="false"
          :readShow="false"
          :operateShow="false"
          @detail="getDetail"
        />
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="pagetotal"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleClose()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableList from "../../components/table_list/index.vue";
export default {
  components: {
    tableList,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pages: 1, // 请求页码
      limit: 10, // 一页多少个
      pagetotal: 0, // 列表总计
      tableData: [],
      tableTitle: [
        {
          label: "通知标题",
          prop: "title",
        },
        {
          label: "通知内容",
          prop: "content",
        },
        {
          label: "通知状态",
          prop: "status",
        },
        {
          label: "通知时间",
          prop: "createtime",
        },
      ],
    };
  },
  created() {
    this.getNotice();
  },
  methods: {
    // 弹窗关闭
    handleClose() {
      this.$emit("close");
    },
    getDetail(e) {
      console.log("获取到了详情", e);
    },
    getNotice() {
      let data = {
        page: this.pages,
        limit: this.limit,
        op: JSON.stringify({
          // cname: "LIKE %...%",
          isread: "IN(...)",
        }),
        filter: JSON.stringify({
          // cname: this.searchText,
          isread: "0",
        }),
      };
      let userInfo = localStorage.getItem('userinfo');
      if(!userInfo){
        return
      }
      this.$http.post("/api/notice/index", data).then((res) => {
        if (res.data.code == 1) {
          this.pagetotal = res.data.data.total;
          this.tableData = res.data.data.rows.map((item) => {
            if (item.createtime) {
              item.createtime = this.$dateTime.transformTime(item.createtime);
              if (item.isread == 1) {
                item.status = "已读";
              } else {
                item.status = "未读";
              }
            }
            return item;
          });
          //   this.tableData = res.data.data.row;
          // console.log("测试东西", this.tableData);
        } else {
          this.$message.error("请求报错，请联系管理员");
          return;
        }
      });
    },
    // 获取页面数据
    pageChange(e) {
      this.pages = e;
      this.getNotice();
    },
  },
};
</script>

<style lang="less" scoped>
.jg-file-viewer {
  z-index: 9990 !important;
}
.addForm {
  position: fixed;
  width: 100vh;
  height: 100wh;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/noticeList.vue